// extracted by mini-css-extract-plugin
export default {"metricsWrapper":"IndependentIraOpenOrders_metricsWrapper__0wzjC"};